// extracted by mini-css-extract-plugin
export default {"sr-only":"Accessibility__sr-only--fRyoV","skip-to-content":"Accessibility__skip-to-content--ETXNp"};